import React, { Component } from "react";
import $ from "jquery";
import Select from "react-select/lib/Creatable";
import "assets/scss/styles.css";
import CheckBox from "./CheckBox";
import DatePicker from "./DatePicker";
import BackButton from "./BackButton";
// import DateTimeField from "./DateTimeField";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Nouislider from "react-nouislider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Demo from "./demo";
import Button from "components/CustomButtons/Button.jsx";
import isEqual from "lodash/isEqual";
import { connect } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import withStyles from "@material-ui/core/styles/withStyles";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";

let selectedTempArr = Demo;
let optionsList = [];
let fetchDataOnSelect = Demo;
let isEnd = false;
let nextInputType = "select";
let isSqlOperatorSelected = false;
let sqlLabels = [];
let sqlValues = [];
let tempKeyValuePairSelectedArr = [];
let tempKeyValuePairResultArr = [];
let navLinks = "";
let showAddQueryButton = false;
let selectedResultQuery = [];
let selectedValueDataLabels = [];
let selectedValueDataValues = [];

const sqlData = [
  { value: "=", label: "is equal to (==)" },
  { value: "= ", label: "is equal to (==)" },
  { value: "!=", label: "is not equal to (!=)" },
  { value: "<", label: "is lesser than (<)" },
  { value: "<=", label: "is lesser than equal to (<=)" },
  { value: ">", label: "is greater than (>)" },
  { value: ">=", label: "is greater than equal to (>=)" },
  { value: "BETWEEN", label: "Between" },
  { value: "NOT BETWEEN", label: "Not in between" },
  { value: "IN", label: "any in" },
  { value: "NOT IN", label: "not in" },
  { value: "cardinality(array_intersect(", label: "includes any of"},
  { value: "cardinality(array_except(", label: "excludes any of"}
];

const sqlSelectionDict = {
  number: [
    { value: "=", label: "is equal to (==)" },
    { value: "!=", label: "is not equal to (!=)" },
    { value: "<", label: "is lesser than (<)" },
    { value: "<=", label: "is lesser than equal to (<=)" },
    { value: ">", label: "is greater than (>)" },
    { value: ">=", label: "is greater than equal to (>=)" },
    { value: "BETWEEN", label: "Between" },
    { value: "NOT BETWEEN", label: "Not in between" }
  ],
  string: [
    { value: "=", label: "is equal to (==)" },
    { value: "!=", label: "is not equal to (!=)" },
    //{ value: "<", label: "is lesser than (<)" },
    //{ value: "<=", label: "is lesser than equal to (<=)" },
    //{ value: ">", label: "is greater than (>)" },
    //{ value: ">=", label: "is greater than equal to (>=)" },
    //{ value: "BETWEEN", label: "Between" },
    //{ value: "NOT BETWEEN", label: "Not in between" }
  ],
  select: [
    { value: "=", label: "is equal to (==)" }
  ],
  select_nonString: [
    { value: "= ", label: "is equal to (==)" }
  ],
  multiSelect: [
    { value: "IN", label: "any in" },
    { value: "NOT IN", label: "not in" }
  ],
  multiSelect_agg: [
    { value: "cardinality(array_intersect(", label: "includes any of" },
    { value: "cardinality(array_except(", label: "excludes any of" }
  ],
  checkbox: [
    { value: "IN", label: "any in" },
    { value: "NOT IN", label: "not in" }
  ],
  radio: [{ value: "=", label: "is equal to (==)" }],
  sliders: [
    { value: "=", label: "is equal to (==)" },
    { value: "!=", label: "is not equal to (!=)" },
    { value: "<", label: "is lesser than (<)" },
    { value: "<=", label: "is lesser than equal to (<=)" },
    { value: ">", label: "is greater than (>)" },
    { value: ">=", label: "is greater than equal to (>=)" }
    // { value: "BETWEEN", label: "Between" },
    // { value: "NOT BETWEEN", label: "Not in between" }
  ],
  datePicker: [{ value: "=", label: "is equal to (==)" }],
  toggle: [{ value: "=", label: "is equal to (==)" }]
};

class Selections extends Component {
  constructor(props) {
    super(props);

    this.handleAcquistionChanges = this.handleAcquistionChanges.bind(this);
    this.prepareOptionsData = this.prepareOptionsData.bind(this);
    this.setPreviousValue = this.setPreviousValue.bind(this);
    this.setNextValue = this.setNextValue.bind(this);
    this.onBackButtonClick = this.onBackButtonClick.bind(this);
    this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
    this.onAddBackButtonClick = this.onAddBackButtonClick.bind(this);
    this.clearSelections = this.clearSelections.bind(this);
  }
  state = {
    error: false,
    segmentName: ""
  };
  componentWillMount() {
    if (
      this.props.mode === "Edit" &&
      this.props.selectedRule !== "" &&
      this.props.selectedIndex !== "no_index"
    ) {
      selectedResultQuery.push(
        this.props.tillSqlSelectionArrSegment[this.props.selectedIndex][
          this.props.selectedRule
        ]
      );
      for (let key in selectedResultQuery[0]) {
        selectedValueDataLabels.push(selectedResultQuery[0][key].label);
        selectedValueDataValues.push(selectedResultQuery[0][key].value);
      }

      this.setState({
        selectedOption: selectedResultQuery[0][0]
      });
    }
    fetchDataOnSelect = Demo;
    isEnd = false;
    nextInputType = "select";
    isSqlOperatorSelected = false;
    sqlLabels = [];
    sqlValues = [];
    tempKeyValuePairSelectedArr = [];
    showAddQueryButton = false;
    this.prepareOptionsData(Demo);
    for (let key in sqlData) {
      let data = sqlData[key];
      sqlValues.push(data.value);
      sqlLabels.push(data.label);
    }
  }

  state = {
    selectedOption: null,
    selectedValue: "select"
  };

  dateFormatter(sampleDate) {
    //FORMAT should be 2018-12-05
    let dictOfMonths = {
      "01": "JAN",
      "02": "FEB",
      "03": "MAR",
      "04": "APR",
      "05": "MAY",
      "06": "JUN",
      "07": "JUL",
      "08": "AUG",
      "09": "SEP",
      "10": "OCT",
      "11": "NOV",
      "12": "DEC"
    };
    let splitDate = sampleDate.split("-");
  }

  _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.onAddBackButtonClick();
    }
  }

  async prepareOptionsData(data) {
    optionsList = [];
    if ($.isArray(data)) {
      data.map((options, key) => {
        if ("label" in options && "value" in options) {
          let optionData = {};
          optionData["label"] = options.label;
          optionData["value"] = options.value;
          optionsList.push(optionData);
        }
      });
    } else {
      optionsList = data;
    }
  }

  async setNextValue(options, setVar = true) {
    if (setVar) {
      await this.setState({ selectedValue: nextInputType });
    }
    if ("type" in options) {
      nextInputType = options.type;
    }
  }

  async setPreviousValue(options, setVar = true) {
    if ("type" in options) {
      nextInputType = options.type;
    }
    if (setVar) {
      await this.setState({ selectedValue: nextInputType });
    }
  }

  async handleAcquistionChanges(selectedValueData) {
    if (this.props.mode === "Edit") {
      let tempKeyValuePairSelectedArrLength =
        tempKeyValuePairSelectedArr.length;
      if (
        selectedResultQuery.length > 0 &&
        $.inArray(selectedValueData.label, sqlLabels) != -1 &&
        $.inArray(selectedValueData.value, sqlValues) != -1
      ) {
        tempKeyValuePairResultArr = [];
        if (nextInputType == "multiSelect" || nextInputType == "multiSelect_agg") {
          if (
            this.props.afterSqlSelectionArrSegment.length > 0 &&
            this.props.afterSqlSelectionArrSegment[this.props.selectedIndex] !==
              undefined &&
            this.props.afterSqlSelectionArrSegment[this.props.selectedIndex][
              this.props.selectedRule
            ] !== undefined
          ) {
            tempKeyValuePairResultArr.push(
              this.props.afterSqlSelectionArrSegment[this.props.selectedIndex][
                this.props.selectedRule
              ]
            );
            this.setState({
              selectedOption: this.props.afterSqlSelectionArrSegment[
                this.props.selectedIndex
              ][this.props.selectedRule]
            });
          }
        } else {
          if (
            this.props.afterSqlSelectionArrSegment.length > 0 &&
            this.props.afterSqlSelectionArrSegment[this.props.selectedIndex] !==
              undefined &&
            this.props.afterSqlSelectionArrSegment[this.props.selectedIndex][
              this.props.selectedRule
            ] !== undefined
          ) {
            this.setState({
              selectedOption: this.props.afterSqlSelectionArrSegment[
                this.props.selectedIndex
              ][this.props.selectedRule][0]
            });
            tempKeyValuePairResultArr.push([
              this.props.afterSqlSelectionArrSegment[this.props.selectedIndex][
                this.props.selectedRule
              ][0]
            ]);
          }
        }
        selectedResultQuery = [];
      } else if (
        selectedResultQuery.length > 0 &&
        $.inArray(selectedValueData.label, selectedValueDataLabels) != -1 &&
        $.inArray(selectedValueData.value, selectedValueDataValues) != -1
      ) {
        this.setState({
          selectedOption:
            selectedResultQuery[0][tempKeyValuePairSelectedArrLength + 1]
        });
      } else {
        selectedResultQuery = [];
        this.setState({ selectedOption: "" });
      }
    }
    showAddQueryButton = false;
    let selectedDetails = {};
    if (!$.isArray(selectedValueData)) {
      let selectedResultValue = selectedValueData.value;
      let selectedResultLable = selectedValueData.label;
      selectedDetails["label"] = selectedResultLable;
      selectedDetails["value"] = selectedResultValue;
    }
    let arrayLength = tempKeyValuePairSelectedArr.length - 1;
    if (
      $.isEmptyObject(tempKeyValuePairSelectedArr) ||
      ($.inArray(tempKeyValuePairSelectedArr[arrayLength].label, sqlLabels) ==
        -1 &&
        $.inArray(tempKeyValuePairSelectedArr[arrayLength].value, sqlValues) ==
          -1)
    ) {
      if (this.props.mode !== "Edit" && this.state.selectedOption != "") {
        await this.setState({ selectedOption: "" });
      }

      await tempKeyValuePairSelectedArr.push(selectedDetails);
      let index = "";
      let tempArr = [];
      let selectedBackData = Demo;
      let isEnd = false;
      let arrCount = 0;
      if (tempKeyValuePairSelectedArr.length > 0) {
        if (
          $.inArray(
            tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
              .label,
            sqlLabels
          ) > -1 &&
          $.inArray(
            tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
              .value,
            sqlValues
          ) > -1
        ) {
          arrCount = tempKeyValuePairSelectedArr.length - 1;
        } else {
          arrCount = tempKeyValuePairSelectedArr.length;
        }
        for (let i = 0; i < arrCount; i++) {
          var equal = isEqual(selectedBackData, Demo); // true
          if (equal) {
            index = Demo.findIndex(
              data => data.value === tempKeyValuePairSelectedArr[i].value
            );
          } else {
            index = selectedBackData.findIndex(
              data => data.value === tempKeyValuePairSelectedArr[i].value
            );
          }
          if (
            selectedBackData[index].hasOwnProperty("end") &&
            selectedBackData[index].end == "true"
          ) {
            if (
              $.inArray(
                tempKeyValuePairSelectedArr[
                  tempKeyValuePairSelectedArr.length - 1
                ].label,
                sqlLabels
              ) > -1 &&
              $.inArray(
                tempKeyValuePairSelectedArr[
                  tempKeyValuePairSelectedArr.length - 1
                ].value,
                sqlValues
              ) > -1
            ) {
              tempArr = selectedBackData[index];
              selectedBackData = selectedBackData[index]["data"];
              showAddQueryButton = true;
            } else {
              isEnd = true;
              tempArr = selectedBackData[index];
              selectedBackData = sqlSelectionDict[tempArr.type];
            }
          } else {
            if ("data" in selectedBackData[index]) {
              tempArr = selectedBackData[index];
              selectedBackData = selectedBackData[index]["data"];
            } else {
              tempArr = selectedBackData[index];
              selectedBackData = selectedBackData[index];
            }
          }
        }
      }
      fetchDataOnSelect = selectedBackData;
      await this.prepareOptionsData(selectedBackData);
      if (!isEnd) {
        await this.setNextValue(tempArr);
      } else {
        await this.setNextValue(tempArr, false);
        this.setState({ selectedValue: "select" });
      }
    } else {
      showAddQueryButton = true;
      tempKeyValuePairResultArr = [];
      if ($.isArray(selectedValueData)) {
        tempKeyValuePairResultArr.push(selectedValueData);
      } else {
        tempKeyValuePairResultArr.push([selectedValueData]);
      }
      this.setState({ selectedOption: selectedValueData });
    }
  }

  async onBackButtonClick() {
    showAddQueryButton = false;
    // tempKeyValuePairSelectedArr.push("segmentName");
    let label =
      tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1].label;
    let value =
      tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1].value;
    let arr = {};
    arr["label"] = label;
    arr["value"] = value;
    await this.setState({ selectedOption: arr });
    let index = "";
    let tempArr = [];
    let selectedBackData = Demo;
    if (tempKeyValuePairSelectedArr.length - 1 > 0) {
      if (
        $.inArray(
          tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
            .label,
          sqlLabels
        ) > -1 &&
        $.inArray(
          tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
            .value,
          sqlValues
        ) > -1
      ) {
        selectedBackData = sqlSelectionDict[nextInputType];
        tempKeyValuePairResultArr = [];
        tempKeyValuePairSelectedArr.pop();
        await this.prepareOptionsData(selectedBackData);
        this.setState({ selectedValue: "select" });
        return false;
      } else {
        for (let i = 0; i < tempKeyValuePairSelectedArr.length - 1; i++) {
          var equal = isEqual(selectedBackData, Demo); // true
          if (equal) {
            index = Demo.findIndex(
              data => data.value === tempKeyValuePairSelectedArr[i].value
            );
          } else {
            index = selectedBackData.findIndex(
              data => data.value === tempKeyValuePairSelectedArr[i].value
            );
          }
          if ("data" in selectedBackData[index]) {
            tempArr = selectedBackData[index];
            selectedBackData = selectedBackData[index]["data"];
          } else {
            tempArr = selectedBackData[index];
            selectedBackData = selectedBackData[index];
          }
          if (i + 1 === tempKeyValuePairSelectedArr.length - 1) {
            tempKeyValuePairSelectedArr.pop();
          }
        }
      }
    } else {
      tempArr = Demo;
      selectedBackData = tempArr;
      tempKeyValuePairSelectedArr.pop();
    }
    fetchDataOnSelect = selectedBackData;
    await this.prepareOptionsData(selectedBackData);
    await this.setPreviousValue(tempArr);
  }

  async handleRadioButtonChange(event) {
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = event.target.value;
    selectedResultValue = (selectedResultValue == 'true') ? true : (selectedResultValue == 'false') ? false : selectedResultValue;
    let selectedResultLable = "";
    let selectedResultValue1 = 0;
    optionsList.map((options, key) => {
      if (options.value == selectedResultValue) {
        selectedResultLable = options.label;
        selectedResultValue1 = options.value;
      }
    });
    selectedDetails["label"] = selectedResultLable;
    selectedDetails["value"] = selectedResultValue1;
    // if (this.props.mode === "Edit") {
    //   tempKeyValuePairResultArr.push([[selectedDetails]]);
    // } else {
    //   tempKeyValuePairResultArr.push([selectedDetails]);
    // }
    tempKeyValuePairResultArr.push([selectedDetails]);
    await this.setState({ selectedOption: selectedDetails });
  }

  async onAddBackButtonClick() {
    // tempKeyValuePairSelectedArr[0].address = "your address";
    // replaceSpace.replace(/ /g, ";");
    if (
      this.props.selectedIndex === "no_index" &&
      (this.state.segmentName === "" || this.state.segmentName === undefined)
    ) {
      return false;
    }
    if (tempKeyValuePairResultArr.length > 0) {
      await this.props.dispatch({
        type: "TILL_SQL_PUSH_SEGMENT",
        payload: tempKeyValuePairSelectedArr,
        selectedIndex: this.props.selectedIndex,
        selectedRule: this.props.selectedRule
      });
      await this.props.dispatch({
        type: "AFTER_SQL_PUSH_SEGMENT",
        payload: tempKeyValuePairResultArr,
        selectedIndex: this.props.selectedIndex,
        selectedRule: this.props.selectedRule
      });
      if (this.props.selectedIndex == "no_index") {
        await this.setState({
          segmentName: this.state.segmentName
        });
        await this.props.dispatch({
          type: "ADD_SEGMENT_NAME",
          payload: this.state.segmentName
        });
        this.setState({ segmentName: "" });
      }
      this.props.dispatch({ type: "CLOSE_MODEL_SEGMENT", payload: "close" });
      this.props.dispatch({ type: "Add_SEGMENT" });
      await this.clearSelections();
      await this.prepareOptionsData(Demo);
      await this.setState({ selectedOption: "", selectedValue: "select" });
    } else {
      // alert("please select atleast one item");
      this.setState({ error: true });
    }
  }
  handleChangeInput = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  handleClose = () => {
    this.props.dispatch({ type: "CLOSE_MODEL_SEGMENT", payload: "close" });
    // var x = [];
    // x["classicModal"] = false;
    // this.setState(x);
  };

  async clearSelections() {
    selectedTempArr = Demo;
    optionsList = [];
    fetchDataOnSelect = Demo;
    isEnd = false;
    nextInputType = "select";
    isSqlOperatorSelected = false;
    sqlLabels = [];
    sqlValues = [];
    tempKeyValuePairSelectedArr = [];
    tempKeyValuePairResultArr = [];
    navLinks = "";
    showAddQueryButton = false;
    for (let key in sqlData) {
      let data = sqlData[key];
      sqlValues.push(data.value);
      sqlLabels.push(data.label);
    }
  }

  prepareNavLinks() {
    navLinks = "";
    for (let nav in tempKeyValuePairSelectedArr) {
      if (tempKeyValuePairSelectedArr.length - 1 == nav) {
        navLinks = navLinks + tempKeyValuePairSelectedArr[nav].label;
      } else {
        navLinks = navLinks + tempKeyValuePairSelectedArr[nav].label + " > ";
      }
    }
  }

  async numberFieldMethod(event) {
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = Number(event.target.value);
    let selectedResultLable = event.target.name;
    selectedDetails["label"] = selectedResultLable;
    selectedDetails["value"] = selectedResultValue;
    tempKeyValuePairResultArr.push([selectedDetails]);
    await this.setState({ selectedOption: selectedDetails });
  }

  async stringFieldMethod(event) {
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = String(event.target.value);
    let selectedResultLable = event.target.name;
    selectedDetails["label"] = selectedResultLable;
    selectedDetails["value"] = selectedResultValue;
    tempKeyValuePairResultArr.push([selectedDetails]);
    await this.setState({ selectedOption: selectedDetails });
  }

  async rangenumberFieldMethod(event) {
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = Number(event.target.value);
    let selectedResultLable = event.target.name;
    selectedDetails["label"] = 'number_field_name';
    if (event.target.name == 'number_field_name') {
      let selectedOpt = this.state.selectedOption;
      if (selectedOpt !== "" && selectedOpt['value'].indexOf('AND') !== -1) {
        let splitData = selectedOpt['value'].split(' AND ');
        selectedDetails["value"] = selectedResultValue + ' AND ' + splitData[1];
        selectedDetails['value'] = selectedDetails['value'].replace(/'/g,'')
      } else {
        selectedDetails["value"] = selectedResultValue + ' AND ' + '0';
        selectedDetails['value'] = selectedDetails['value'].replace(/'/g,'')
      }
      tempKeyValuePairResultArr.push([selectedDetails]);
      await this.setState({ selectedOption: selectedDetails });
    } else {
      let selectedOpt = this.state.selectedOption;
      if (selectedOpt !== "" && selectedOpt['value'].indexOf('AND') !== -1) {
        let splitData = selectedOpt['value'].split(' AND ');
        selectedDetails["value"] = splitData[0] + ' AND ' + selectedResultValue;
        selectedDetails['value'] = selectedDetails['value'].replace(/'/g,'')
      } else {
        selectedDetails["value"] = '0' + ' AND ' + selectedResultValue;
        selectedDetails['value'] = selectedDetails['value'].replace(/'/g,'')
      }
      tempKeyValuePairResultArr.push([selectedDetails]);
      await this.setState({ selectedOption: selectedDetails });
    }
  }

  render() {
    const { classes } = this.props;
    const { selectedOption, selectedValue } = this.state;
    let htmlContent = "";
    let showButton = "";
    if (tempKeyValuePairSelectedArr.length > 0) {
      showButton = (
        // <div className="gobackinfo">
        <a
          href="javascript:void(0)"
          onClick={() => this.onBackButtonClick()}
          // className="btn btngoback"
          style={{ color: "black", padding: "15px", marginRight: "10px" }}
        >
          {"<"}
          Go Back
        </a>
      );
    }
    {
      this.prepareNavLinks();
    }
    if (selectedValue === "select" || selectedValue === "select_nonString" || selectedValue == "multiSelect" || selectedValue == "multiSelect_agg") {
      htmlContent = (
        <div>
          <div
            id="classic-modal-slide-title"
            disableTypography
            // className="gobackinfo"
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px"
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px"
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </div>

          <DialogContent
            id="classic-modal-slide-description"
            style={{
              paddingTop: "24px",
              paddingRight: "24px",
              paddingBottom: "16px",
              paddingLeft: "24px",
              position: "relative",
              overflow: "visible"
            }}
          >
            <Select
              value={selectedOption}
              onChange={this.handleAcquistionChanges}
              options={optionsList}
              style={{ width: "100%" }}
              isMulti={selectedValue == "multiSelect" ? true : selectedValue == "multiSelect_agg" ? true : false}
            />
          </DialogContent>
        </div>
      );
    } else if (selectedValue === "number") {
      let selectedNumberValue = "";
      let selectedNumberValue1 = "";
      let selectedNumberValue2 = "";
      if (((tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1].label == 'Between') && (tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1].value === 'BETWEEN'))
       || ((tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1].label == 'Not in between') && (tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1].value === 'NOT BETWEEN'))) {
        if (selectedOption.hasOwnProperty("value")) {
          let selVal = String(selectedOption.value);
          if (selVal.indexOf('AND') !== -1) {
            selVal = selectedOption.value.split(" AND ")
            selectedNumberValue1 = selVal[0];
            selectedNumberValue2 = selVal[1];
          }
        }
        htmlContent = (
          <div>
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              style={{
                backgroundColor: "#d8d8d8",
                borderBottom: "none",
                padding: "10px",
                marginBottom: "10px"
              }}
            >
              <p
                style={{
                  color: "#d8d8d8",
                  margin: "0",
                  paddingLeft: "0px"
                }}
              >
                <GridContainer>
                  <GridItem xs={3}>{showButton}</GridItem>
                  <GridItem xs={9}>
                    <span style={{ color: "black" }}>
                      <strong>Filter:</strong> &nbsp;
                      {navLinks}
                    </span>
                  </GridItem>
                </GridContainer>
              </p>
            </DialogTitle>
            {optionsList.map((options, key) => (
              <React.Fragment>
                <TextField
                  style={{
                    width: "48%",
                    marginTop: "2%"
                  }}
                  label="Please enter your input"
                  value={selectedNumberValue1}
                  onChange={event => this.rangenumberFieldMethod(event)}
                  type="number"
                  name="number_field_name"
                  inputProps={{
                    min: options.value,
                    max: options.label,
                    shrink: true,
                    key: key
                  }}
                  margin="normal"
                />
                <TextField
                  style={{
                    width: "48%",
                    marginTop: "2%",
                    paddingLeft: "2%"
                  }}
                  label="Please enter your input"
                  value={selectedNumberValue2}
                  onChange={event => this.rangenumberFieldMethod(event)}
                  type="number"
                  name="number_field_name_range"
                  inputProps={{
                    min: options.value,
                    max: options.label,
                    shrink: true,
                    key: key
                  }}
                  margin="normal"
                />
              </React.Fragment>
            ))}
          </div>
        );
      } else {
        if (selectedOption.hasOwnProperty("value")) {
          selectedNumberValue = selectedOption.value;
        }
        htmlContent = (
          <div>
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              style={{
                backgroundColor: "#d8d8d8",
                borderBottom: "none",
                padding: "10px",
                marginBottom: "10px"
              }}
            >
              <p
                style={{
                  color: "#d8d8d8",
                  margin: "0",
                  paddingLeft: "0px"
                }}
              >
                <GridContainer>
                  <GridItem xs={3}>{showButton}</GridItem>
                  <GridItem xs={9}>
                    <span style={{ color: "black" }}>
                      <strong>Filter:</strong> &nbsp;
                      {navLinks}
                    </span>
                  </GridItem>
                </GridContainer>
              </p>
            </DialogTitle>
            {optionsList.map((options, key) => (
              <TextField
                style={{
                  width: "100%",
                  marginTop: "2%"
                }}
                label="Please enter your input"
                value={selectedNumberValue}
                onChange={event => this.numberFieldMethod(event)}
                type="number"
                name="number_field_name"
                inputProps={{
                  min: options.value,
                  max: options.label,
                  shrink: true,
                  key: key
                }}
                margin="normal"
              />
            ))}
          </div>
        );
      }
    } 
    
     else if (selectedValue === "string") {
      let selectedNumberValue = "";
        if (selectedOption.hasOwnProperty("value")) {
          selectedNumberValue = selectedOption.value;
        }
        htmlContent = (
          <div>
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              style={{
                backgroundColor: "#d8d8d8",
                borderBottom: "none",
                padding: "10px",
                marginBottom: "10px"
              }}
            >
              <p
                style={{
                  color: "#d8d8d8",
                  margin: "0",
                  paddingLeft: "0px"
                }}
              >
                <GridContainer>
                  <GridItem xs={3}>{showButton}</GridItem>
                  <GridItem xs={9}>
                    <span style={{ color: "black" }}>
                      <strong>Filter:</strong> &nbsp;
                      {navLinks}
                    </span>
                  </GridItem>
                </GridContainer>
              </p>
            </DialogTitle>
            {optionsList.map((options, key) => (
              <TextField
                style={{
                  width: "100%",
                  marginTop: "2%"
                }}
                label="Please enter your input"
                value={selectedNumberValue}
                onChange={event => this.stringFieldMethod(event)}
                type="text"
                name="string_field_name"
                inputProps={{
                  min: options.value,
                  max: options.label,
                  shrink: true,
                  key: key
                }}
                margin="normal"
              />
            ))}
          </div>
        );
    }



    else if (selectedValue === "checkbox") {
      htmlContent = (
        <div
        // style={{
        //   paddingLeft: "20px",
        //   paddingTop: "30px",
        //   paddingRight: "20px"
        // }}
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px"
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px"
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          <GridContainer>
            {optionsList.map(options => (
              <GridItem xs={3} key={options.value}>
                <CheckBox
                  key={options.value}
                  checkBoxChange={this.handleCheckBoxChange}
                  value={options.value}
                  label={options.label}
                />
              </GridItem>
            ))}
          </GridContainer>
        </div>
      );
    } else if (selectedValue === "radio") {
      let selectedRadioValue = "";
      if (selectedOption.hasOwnProperty("value")) {
        selectedRadioValue = selectedOption.value;
      }
      htmlContent = (
        <div>
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px"
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px"
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          <div
            style={{
              paddingLeft: "20px",
              paddingTop: "30px",
              paddingRight: "20px"
            }}
          >
            <RadioGroup
              name="radio_button"
              value={selectedRadioValue}
              onChange={this.handleRadioButtonChange}
            >
              {optionsList.map((options, key) => (
                <FormControlLabel
                  key={key}
                  value={options.value}
                  control={<Radio color="primary" />}
                  label={options.label}
                />
              ))}
            </RadioGroup>
          </div>
        </div>
      );
    } else if (selectedValue === "sliders") {
      htmlContent = (
        <div
          style={{
            paddingLeft: "20px",
            paddingTop: "30px",
            paddingRight: "20px"
          }}
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px"
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px"
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          <GridItem xs={12} sm={12} md={6}>
            <legend>Sliders</legend>
            <Nouislider
              start={[40]}
              connect={[true, false]}
              step={1}
              range={{ min: 0, max: 100 }}
            />
          </GridItem>
        </div>
      );
    } else if (
      selectedValue === "datePicker" ||
      selectedValue === "timePicker" ||
      selectedValue === "dateTimePicker"
    ) {
      htmlContent = (
        <div
          style={{
            paddingLeft: "20px",
            paddingTop: "30px",
            paddingRight: "20px"
          }}
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px"
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px"
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={4}>{showButton}</GridItem>
                <GridItem xs={8}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          <DatePicker
            startDate
            datePickerValue={this.handleDatePickerChange}
            selectedValue={selectedValue}
          />
        </div>
      );
    }
    if (showAddQueryButton) {
      showButton = (
        <BackButton
          icon="rightIcon"
          buttonName="Add"
          buttonLabel="Add"
          color="default"
          onAddButtonClick={this.onAddBackButtonClick}
        />
      );
      let content = (
        <div
          style={{
            paddingLeft: "20px",
            paddingTop: "30px",
            paddingRight: "20px",
            float: "right"
          }}
        >
          {showButton}
        </div>
      );
      let textBox = "";
      if (this.props.selectedIndex === "no_index") {
        textBox = (
          //<form className={classes.container} autoComplete="off" action="javascript:myFunction(); return false;">
            <center>
              <TextField
                id="segmentName"
                label="Segment Name"
                className={classes.textField}
                value={this.state.segmentName}
                onChange={event => this.handleChangeInput(event, "segmentName")}
                style={{ width: "750px" }}
                // margin="normal"
                onKeyPress={this._handleKeyPress}
                hintText="Hint Text (MultiLine)"
                multiLine={true}
                maxLength="2"
                // />
              />
            </center>
         // </form>
        );
      }
      return (
        <React.Fragment>
          {htmlContent}
          {textBox}
          <span
            style={{ color: "red", marginLeft: "25%" }}
            className={this.state.error ? "block" : "hidden"}
          >
            Please Select atleast One item
          </span>
          <br />
          <DialogActions
            style={{
              padding: "15px",
              textAlign: "right",
              paddingTop: "0",
              margin: "0"
            }}
          >
            {/* <span className={this.state.error ? "block" : "hidden"}>Error</span> */}
            <div className="popupbtngroup">
              {/* <a
                href="javascript:void(0)"
                className="btn popbtn"
                onClick={this.handleClose}
                key="close"
                aria-label="Close"
              >
                cancel
              </a> */}
              {/* <a
                href="javascript:void(0)"
                className="btn popbtn"
                onClick={this.onAddBackButtonClick}
              >
                apply
              </a> */}
              <Button
                className="btn btncreate"
                // className="buttonRight"
                color="secondary"
                onClick={this.handleClose}
              >
                Cancel
              </Button>
              <Button
                className="btn btncreate"
                // className="buttonRight"
                color="secondary"
                onClick={this.onAddBackButtonClick}
              >
                Apply
              </Button>
            </div>
          </DialogActions>
        </React.Fragment>
      );
    }
    return <React.Fragment>{htmlContent}</React.Fragment>;
  }
}

const mapStateToProps = state => ({
  countSegment: state.count,
  tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
  afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
  isModalOpenSegment: state.isModalOpenSegment,
  groupLeveltoggleSegment: state.groupLeveltoggleSegment,
  ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
  segmentName: state.segmentName
});

export default connect(mapStateToProps)(
  withStyles(notificationsStyle)(Selections)
);



// WEBPACK FOOTER //
// ./src/views/Audiences/SegmentQueryBuilder/Selections.jsx